import AdminService from '../services/admin.services'

const state = {
    logs: []
}

const getters = {
    getLogs: (state) => state.logs
}

const actions = {
    requestLogs({commit}, data){
        return AdminService.post_entity(data.payload, data.entity).then(
            response => {
                commit('SET_LIST', response.data)
                return Promise.resolve(response.status)
            }
        )
    }
}

const mutations = {
    SET_LIST(state, rs){
        state.logs = rs.data
    }
}

export const logs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}